<template>
  <div>
    <UContent
      :has-title-delimiter="true"
      :has-padding="false"
    >
      <template #title>
        <span>{{ $t("activeSession.titleActiveSession") }}</span>
      </template>
      <template #subtitle>
        <span>{{ $t("activeSession.subTitle1") }} {{ totalItems }}
          {{ $t("activeSession.subTitle2") }}</span>
      </template>
      <template #header-right>
        <UButton
          :severity="'secondary'"
          @click="closeActiveSession"
        >
          {{ $t("activeSession.btnOut") }}
        </UButton>
      </template>
      <template #content>
        <ProgressLoader
          v-if="loading"
          mode="indeterminate"
          color="#5AC396"
        />
        <UListItem
          v-for="(item, index) in activeSession"
          :key="index"
          v-bind="item"
        />
        <UPaginator
          v-if="totalItems > itemsPerPage"
          :rows="itemsPerPage"
          :total-records="totalItems"
          @page="changePage($event)"
        />
      </template>
    </UContent>
  </div>
</template>

<script setup>
import i18n from "@/localization/localization";
import moment from "moment";
import ProgressLoader from "@/loaders/progress-bar";
import UListItem from "@/components/uikit/uComponents/UListItem.vue";
import UPaginator from "@/components/uikit/uComponents/UPaginator.vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";

// Variables
const store = useStore();
const toast = useToast();
const t = (key) => i18n.global.t(key);
const loading = ref(true);
const page = ref(1);
const itemsPerPage = ref(30);
const totalItems = ref(0);
const activeSession = ref([]);

// Methods
const getActiveSession = async () => {
  loading.value = true;
  activeSession.value = [];
  try {
    const resp = await store.dispatch("profile/getActiveSession", {
      page: page.value,
      itemsPerPage: itemsPerPage.value
    });
    totalItems.value = resp["hydra:totalItems"];
    converArray(resp["hydra:member"]);
  }
  catch (error) {
    console.error("Error:", error);
  }
  finally {
    loading.value = false;
  }
};

const closeActiveSession = async () => {
  try {
    await store.dispatch("profile/closeActiveSession");
    toast.success(t("activeSession.toastSuccess"));
    setTimeout(() => {
      window.location.href = "/logout";
    }, 2000);
  }
  catch (error) {
    toast.error(t("activeSession.toastError"));
  }
  finally {
    loading.value = false;
  }
};

const converArray = (array) => {
  if (!array || !Array.isArray(array)) {
    activeSession.value = [];
    return;
  }

  activeSession.value = array.map((item) => ({
    label: "id: " + item.id,
    value: moment(item.updatedAt).format("DD.MM.YYYY")
  }));
};
const changePage = (data) => {
  page.value = data.page + 1;
  getActiveSession();
};

// Mounted
getActiveSession();
onMounted(() => {});
</script>

<style lang="scss" scoped></style>
